import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';
import { cancelSubAction } from '../actions';

export function* cancelSubscription({ payload }) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.CANCEL_SUB,
      data: { now: payload },
    });
    yield call(toast.success, `Current period end ${moment(res?.data?.current_period_end * 1000).format('D.MM.YYYY')}`);
    yield put(cancelSubAction.success({
      currentPeriodEnd: moment(res?.data?.current_period_end * 1000).format('D.MM.YYYY'),
    }));
    yield put({ type: 'GET_PROFILE_INFO' });
  } catch (e) {
    if (e.message.includes('No such subscription')) {
      yield call(toast.error, 'No such subscription');
      yield put(cancelSubAction.error(e.message));
      return;
    }
    yield call(toast.error, e.message);
    yield put(cancelSubAction.error(e.message));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.CANCEL_SUB, cancelSubscription);
}
